// Unpublished Work © 2024 Deere & Company.

export const translationStore: Record<string, string> = {};

export function setTranslations(translations: Record<string, string>): void {
    Object.assign(translationStore, translations);
}

export function freezeStore(): void {
    Object.freeze(translationStore);
}
